module.exports = __webpack_public_path__ + "img/1.5e9897cc.jpg";